import React from "react";
import { Icon } from "../../../services/visualLibraryService";
import {
  ProfileItemStyled,
  AvatarStyled,
  IconStyled,
  ImageStyled,
  ProfileLogoStyled,
  ProfileNameStyled,
  TextStyled,
  LockIconStyled
} from "./styles/Styled";

const IMAGE = "image";
const EDIT = "edit";

const ProfileItem = ({ focused, currentIndex, profileItem, defaultAvatar }) => {
  return (
    <ProfileItemStyled>
      {profileItem.createNewProfile ? (
        <AvatarStyled isFocused={focused} showAddProfile={true} name={IMAGE}>
          <ImageStyled src={profileItem?.avatar} name={IMAGE} />
        </AvatarStyled>
      ) : (
        <>
          <IconStyled isRowSelected={focused} isFocused={focused && currentIndex === 1 ? true : false} name={EDIT}>
            <Icon name={EDIT} />
          </IconStyled>
          <AvatarStyled isRowSelected={focused} isFocused={focused && currentIndex === 2 ? true : false} name={IMAGE}>
            <ImageStyled src={profileItem?.avatar || defaultAvatar} alt="" name={IMAGE} />
            {profileItem?.profileCategory?.toLowerCase() === "kids" && (
              <ProfileLogoStyled src="/images/icons/kids-profile.png" alt="" name={IMAGE} />
            )}
          </AvatarStyled>
        </>
      )}
      <ProfileNameStyled isFocused={focused}>
        <TextStyled text={profileItem?.profileName} />
        {(profileItem?.isProfileLocked || profileItem?.isKidLockEnabled) && <LockIconStyled name="lock" />}
      </ProfileNameStyled>
    </ProfileItemStyled>
  );
};

export default ProfileItem;
